import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import OverheadCraneTopHead from './overhead-crane-top-head';
import OverheadCraneContent from './overhead-crane-content';
import OverheadCraneModals from './overhead-crane-modals';
import { actions as overheadCraneActions, fetchOverheadCranesWithFilters } from './store/slice';

const { resetFilters } = overheadCraneActions;

const OverheadCraneView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchOverheadCranesWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Overhead Crane</h4>
              </div>
            </div>
            <OverheadCraneTopHead />
          </div>
          <OverheadCraneContent />
          <OverheadCraneModals />
        </div>
      </div>
    </div>
  );
};

export default OverheadCraneView;
